import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TechnologyDetailHero from './components/TechnologyDetailHero';
import FrontendTechnologies from './components/FrontendTechnologies';
import BackendTechnologies from './components/BackendTechnologies';
import IosTechnologies from './components/IosTechnologies';
import AndroidTechnologies from './components/AndroidTechnologies';
import ThirdPartyServices from './components/ThirdPartyServices';
import CloudSolutionTechnologies from './components/CloudSolutionTechnologies';
import ContactFormWidget from '../../../components/ContactFormWidget';
import Footer from '../../../components/Footer';
import herobanner from '../../../assets/Images/herobanner3.jpg';

const TechnologyStack = () => {
  const location = useLocation();

  useEffect(() => {
    // Get the hash from the URL (e.g., #frontend or #backend)
    const hash = location.hash;
    if (hash) {
      // Remove the # from the hash
      const element = document.getElementById(hash.slice(1));
      if (element) {
        // Wait for the page to load and then scroll
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="technology-detail-page">
      <TechnologyDetailHero />
      <div id="frontend">
        <FrontendTechnologies />
      </div>
      <div id="backend">
        <BackendTechnologies />
      </div>
      <div id="ios">
        <IosTechnologies />
      </div>
      <div id="android">
        <AndroidTechnologies />
      </div>
      <div id="third-party">
        <ThirdPartyServices />
      </div>
      <div id="cloud">
        <CloudSolutionTechnologies />
      </div>
      <ContactFormWidget />
      <Footer />
    </div>
  );
};

export default TechnologyStack; 